import React from "react";
import styled from "styled-components";
import { devices } from "../../styles";

export default function Header() {
  return (
    <HeaderContent>
        <HeaderInner>
            <img src="./logo.svg" width="363" height="64" alt="logo" />
        </HeaderInner>
    </HeaderContent>
  )
}

const HeaderContent = styled.div`
  @media ${devices.M} {
  }
`;
const HeaderInner = styled.div`
  max-width: 1165px;
  margin: 0 auto;
  position: relative;

  @media ${devices.S} {
    img {
      display: none;
    }
  }

  @media ${devices.M} {
    img {
      position: absolute;
      top -60px;
      left: -15px;
      transform: scale(0.7);
    }
  }


  @media ${devices.L} {
    img {
      position: absolute;
      top -80px;
      transform: scale(1);
      left:0;
    }
  }
`;